import { FC, SVGProps } from "react";

const SvgIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="currentColor" aria-hidden {...props} />
);

// Гармонические курсоры - вертикальные линии на кратных частотах
export const HarmonicCursorsIcon: FC = () => (
  <SvgIcon>
    <path d="M4 20V4h1.5v16H4zm5.5-12v12H11V8h-1.5zm5.5-4v16H16V4h-1.5zm5.5 6v10H22v-10h-1.5z" opacity={0.35} />
    <path d="M4 20V4h1v16H4zm6-8v8h1v-8h-1zm6-4v12h1V8h-1zm6 2v10h1V10h-1z" fill="#d32f2f" />
  </SvgIcon>
);

// Субгармонические курсоры - линии на дробных частотах
export const SubHarmonicCursorsIcon: FC = () => (
  <SvgIcon>
    <path
      d="M3 20V4h1.5v16H3zm3.5-6v6H8v-6H6.5zm4-4v10h1.5V10H10.5zm4.5-6v16H16V4h-1.5zm5 8v8h1.5v-8H20.5z"
      opacity={0.35}
    />
    <path d="M3 20V4h1v16H3zm4.25-3v3h1v-3h-1zm4.75-5v8h1V7h-1zm5.25-7v15h1V5h-1zm5.25 4v11h1V9h-1z" fill="#1565c0" />
  </SvgIcon>
);

// Частоты неисправностей - маркеры на спектре
export const FaultFrequenciesIcon: FC = () => (
  <SvgIcon>
    <path d="M3 17.5 7.5 12 11 15.5 15 9.5 18.5 13 21 10.5V20H3v-2.5z" opacity={0.25} />
    <path d="M3 17.5 7.5 12 11 15.5 15 9.5 18.5 13 21 10.5" fill="none" stroke="currentColor" strokeWidth={1.5} />
    <circle cx={7.5} cy={12} r={1.5} fill="#f59e0b" />
    <circle cx={15} cy={9.5} r={1.5} fill="#d32f2f" />
    <circle cx={21} cy={10.5} r={1.5} fill="#43a047" />
  </SvgIcon>
);

// Частотный профиль - срез каскада спектров на выбранной частоте
export const FrequencyProfileIcon: FC = () => (
  <SvgIcon>
    <path d="M3 19 11 14.5 21 19" fill="none" stroke="currentColor" strokeWidth={1.2} opacity={0.35} />
    <path d="M3 14 11 9.5 21 14" fill="none" stroke="currentColor" strokeWidth={1.2} opacity={0.65} />
    <path d="M3 9 11 4.5 21 9" fill="none" stroke="currentColor" strokeWidth={1.2} />
    <path d="M11 3v18" fill="none" stroke="#3f6db5" strokeWidth={1.75} />
  </SvgIcon>
);

// Маркер - фиксированная вертикальная линия на графике
export const MarkerIcon: FC = () => (
  <SvgIcon>
    <path d="M4 20h16" fill="none" stroke="currentColor" strokeWidth={1.5} opacity={0.45} />
    <path d="M12 4v16" fill="none" stroke="currentColor" strokeWidth={2} />
    <path d="m8.5 4 3.5 4 3.5-4z" />
  </SvgIcon>
);

// Синхронизация курсоров - связанные вертикальные курсоры на нескольких окнах
export const SyncCursorsIcon: FC = () => (
  <SvgIcon>
    <path d="M8 6v14" fill="none" stroke="currentColor" strokeWidth={1.75} />
    <path d="M16 6v14" fill="none" stroke="currentColor" strokeWidth={1.75} />
    <path d="m6.4 6 1.6 2.4L9.6 6z" />
    <path d="m14.4 6 1.6 2.4L17.6 6z" />
    <path d="M8 13.5h8" fill="none" stroke="#1976d2" strokeWidth={1.5} strokeLinecap="round" />
    <path
      d="m14.2 11.7 1.8 1.8-1.8 1.8"
      fill="none"
      stroke="#1976d2"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m9.8 11.7-1.8 1.8 1.8 1.8"
      fill="none"
      stroke="#1976d2"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

// Каскад / наложение - слои спектров
export const CascadeLayoutIcon: FC = () => (
  <SvgIcon>
    <path d="M4 16.5 12 12l8 4.5V19l-8 4.5-8-4.5v-2.5z" opacity={0.4} />
    <path d="M4 11.5 12 7l8 4.5V14l-8 4.5-8-4.5V11.5z" opacity={0.7} />
    <path d="M4 6.5 12 2l8 4.5V9l-8 4.5L4 9V6.5z" />
  </SvgIcon>
);
